import React, { useState, useEffect } from "react";

const EditCell = ({value: initialValue, row: { index }, column: { id, editInputType = 'text', width, disabled, setTableData, rowEditing },
}) => {
  const [value, setValue] = useState(initialValue)
    // We need to keep and update the state of the cell normally

    const onChange = e => {
      setValue(e.target.value)
    };

    // We'll only update the external data when the input is blurred
    const onBlur = () => {
      setTableData(old =>
        old.map((row, oldIndex) => {
          if (oldIndex === index) {
            return {
              ...old[index],
              [id]: value,
            }
          }
          return row
        })
      )
    };
    
    // If the initialValue is changed external, sync it up with our state
    useEffect(() => {
      setValue(initialValue)
    }, [initialValue]);

    return <input className={`py-3 outline-none border rounded-lg bg-transparent text-xs font-semibold text-gray-600 focus:border-transparent
        ${index === rowEditing && !disabled ? 'border-gray-200 px-4' : 'border-transparent focus:ring-0 px-0'}
      `}
      // style={{width: width + 'px'}}
      readOnly={!(index === rowEditing) || disabled}
      type={editInputType}
      defaultValue={value}
      onChange={onChange}
      onBlur={onBlur}
    />
};

export default EditCell;